"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterWithButtonGroup = FilterWithButtonGroup;
var React = _interopRequireWildcard(require("react"));
var _ButtonGroup = require("../ButtonGroup");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Компонент выполняет функцию адаптера над ButtonGroup
 * Реализация ButtonGroup может измениться или переехать в ui-kit.
 * Компонент FilterWithButtonGroup помогает совместить общий интерфейс фильтров к интерфейсу кнопок
 * */

function FilterWithButtonGroup(props) {
  const {
    value,
    values,
    onValueChange,
    testId
  } = props;
  return /*#__PURE__*/React.createElement(_ButtonGroup.ButtonGroup, {
    testId: testId,
    currentActiveValue: value,
    buttons: values,
    onChange: onValueChange,
    fullWidth: true
  });
}